<template>
<section class="flexbox-container bd-highlight">
  <!-- --------------start modal acsept----------- -->
        <div class="modal fade animated slideInDown text-left" id="modalEq" tabindex="-1" v-if="$store.state.modalBody">
            <div class="modal-dialog" role="document" >
            <div class="modal-content">
                <div class="card-header" style="border-radius: 0.27rem">
                    <h4 class="card-title">Надіслати інформацію про завершення рейсу</h4>
                    <div class="heading-elements">
                        <button type="button" id="closeBtn" ref="closeModalEq" class="btn btn-warning" data-dismiss="modal" @click="$store.state.modalBody = false">
                          <i class="icon-cross" style="color: white"></i>
                        </button>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="container">
                        <div class="row">                            
                            <div class="col-md-4 d-flex justify-content-center pr-1" style="margin-top:13px;">                                
                                <div class="form-group w-100" style="position: relative">                                                            
                                    <fieldset class="form-group position-relative w-100">                                      
                                        <button class="btn btn-primary btn-lg w-100" type="button" data-toggle="modal"  data-target="#modalEq" @click.prevent="completeDelivery">
                                            Завершити рейс
                                        </button>   
                                    </fieldset>                                
                                </div>
                            </div>                       
                        </div>   
                </div>
                 </div>
               
            </div>
            </div>
        </div>
    <!-- -------------- and modal----------- -->
 <div class="d-flex flex-column bd-highlight mb-3">
  <div class="d-flex justify-content-center bd-highlight mb-3 content">    
      <div class="card-body text-center" v-if="sendSuccess">
        <div class="card-content col-md-6 justify-content-center">
            <img  class="img-fluid mx-auto d-block pt-1" src="../assets/pictures/arrow-success1.png" alt="success"> 
        </div>
        <div class="card-body col-md-6 justify-content-center">
             <h1 class="" style="text-align:center">Дані успішно надіслані</h1>
        </div>
      </div> 
      <div v-if="sendError" class="w-100 card ">  
        <div class="card-content col-md-6 justify-content-center">
            <img  class="img-fluid mx-auto d-block pt-1" src="../assets/pictures/arrow-wrong.png" alt="wrong"> 
        </div>
        <div class="card-body col-md-6 justify-content-center">
             <h1 class="" style="text-align:center">Дані не передано, спробуйте повторити запит</h1>        
            <button class="btn btn-primary btn-lg w-100 mb-2" @click="sendGeo" >Надіслати геодані</button> 
        </div>          
      </div>
  </div>
  <div class="d-flex justify-content-center bd-highlight mb-1 footer">
      <button  class="btn btn-success btn-block mb-2 mt-1 btn-lg" type="button" data-toggle="modal" data-target="#modalEq" @click="showmodals">
        Завершити рейс
     </button>
  </div>
 
  
</div>
</section>  
</template>
<script>  
  
  export default {
      name: "Traker",
      components: {},
      data() {
          return {  
            id:null,
            guid:null,
            sendSuccess:false,
            sendError:false,
            geoPermision:null,
            positions:null,
            complDelivery:false
          }           
        },
        methods: {

          showmodals(){
            this.$store.state.modalBody = true;
            this.sendSuccess = false;           
          },
          completeDelivery(){
            this.complDelivery = true;
            this.sendGeo();
          },
          sendGeo(){
             this.getGPS()
                .then(result => {
                  let position = {}
                  position["latitude"] = result.latitude;
                  position["longitude"] = result.longitude;
                  position["accuracy"] = result.accuracy;
                  position["id"] = this.id;
                  position["numberDoc"] = this.guid;
                  position["completeDelivery"] = this.complDelivery;
                  if (_.isNil(position.latitude) || _.isNil(position.longitude)){
                    this.geoPermision = false 
                    this.showNotification('custom-error','Error','Дані не отримано, перевірте наявність дозволу на визначення місцезнаходження та перезавантажте сторінку!!!');                    
                  }
                  else {
                    // this. startevent()
                    this.sendGeodata("/portal/addcoordinate", {dataRequest : position,})
                      .then(result => { 
                                                                               
                              if(result.length > 0 || result.data != false){
                                  this.showNotification('custom-success','Успіх' ,'Дані по геолокації успішно передані!');
                                  this.sendSuccess = true;
                                  this.startevent();
                              } 
                              else {
                                this.showNotification('custom-error','Error' ,'Дані не передано, спробуйте повторити запит');
                                this.sendError = true;
                              }
                      })
                      .catch(error => {
                          console.log("GET error" + error); 
                      }); 
                  }                             
                });
          },
         startevent(){
           console.log("start job")
           let delay = 60000;
           let self = this;
           let timerId = setTimeout(function request() { 
            self.getGPS()
             .then(result => {
                  let position = {}
                  position["latitude"] = result.latitude;
                  position["longitude"] = result.longitude;
                  position["accuracy"] = result.accuracy;
                  position["id"] = self.id;
                  position["numberDoc"] = self.guid;
                  if (_.isNil(position.latitude) || _.isNil(position.longitude)){
                    delay = 6000;
                    console.log("fail get geodata")
                  }
                  else {                    
                    const resp =  new Promise((resolve, reject) => {axios.post("/portal/addcoordinate", position)
                    .then(response => {                 
                      if (response.status == 200){
                        console.log("stus 200")
                        delay = 60000;
                      }                      
                      })
                  })
                    return position; 
                    }                 
             })                                
            timerId = setTimeout(request, delay)
          }, delay);
         }

        
        },
        computed: {
       
        },
        components: {
        },
        // id=15541251455&guid=1256464DFfdgf
        mounted () {        
          this.id = this.$route.query.id;
          this.guid = this.$route.query.guid;
          this.sendGeo();        
        },
        watch:{
          /*'dataEquipment.refrigerant.weight': function(){
            return
          }*/
        },
        created(){
          // console.log("loadead")
        }
    }
</script>

<style>
.content {
  min-height:100%;
  position:relative;
  margin-bottom: 100px;
    }
.flex-column {
    -ms-flex-direction: column!important;
    flex-direction: column!important;

}
.footer {
width: 100%;
position: absolute;
bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Traker.vue